import { initializeYup, isEmpty } from "@duosoftbg/nacid-components";
import * as yup from "yup";
import { YEAR_VALIDATION_REGEX } from "../utils/regexExpressions";
import i18n from "i18next";

export const createSEEducationValidationSchema = () => {
  initializeYup(yup);

  const schema = yup.object({
    recognitionPurposes: yup.array().min(1),
    schoolCountry: yup.object({
      id: yup.string().required(),
    }),
    schoolGradingScaleCountry: yup.object({
      id: yup.string().test("required", i18n.t("validation.field.select"), function (_value) {
        const hasCertificate = this?.options?.context?.hasCertificate;
        const hasOfficialNote = this?.options?.context?.hasOfficialNote;
        if (hasCertificate || hasOfficialNote) {
          return !isEmpty(_value);
        }
        return true;
      }),
    }),
    schoolSettlement: yup.string().required().max(250, i18n.t("validation.charCount.invalid.250")),
    schoolName: yup.string().required().max(250, i18n.t("validation.charCount.invalid.250")),
    diplomaNumber: yup.string().nullable().max(100, i18n.t("validation.charCount.invalid.100")),
    diplomaDate: yup.string().nullable().max(20, i18n.t("validation.charCount.invalid.20")),
    diplomaYear: yup
      .string()
      .required()
      .matches(YEAR_VALIDATION_REGEX)
      .max(20, i18n.t("validation.charCount.invalid.20")),
    diplomaRegisterURL: yup.string().nullable().max(250, i18n.t("validation.charCount.invalid.250")),
    diplomaApostilleURL: yup.string().nullable().max(250, i18n.t("validation.charCount.invalid.250")),
    professionBgTitle: yup.string().nullable().max(2000, i18n.t("validation.charCount.invalid.2000")),
    professionNativeTitle: yup.string().nullable().max(2000, i18n.t("validation.charCount.invalid.2000")),
    gradingScale: yup.object({
      id: yup.string().test("required", i18n.t("validation.field.select"), function (_value) {
        const hasCertificate = this?.options?.context?.hasCertificate;
        const hasOfficialNote = this?.options?.context?.hasOfficialNote;
        if (hasCertificate || hasOfficialNote) {
          return !isEmpty(_value);
        }
        return true;
      }),
    }),
    studiedSubjects: yup.array().of(
      yup.object().shape({
        translatedSubjectName: yup.string().nullable().max(100, i18n.t("validation.charCount.invalid.100")),
        subjectName: yup.string().nullable().max(100, i18n.t("validation.charCount.invalid.100")),
        diplomaGrade: yup.string().nullable().max(20, i18n.t("validation.charCount.invalid.20")),
      }),
    ),
    additionalSubjects: yup.object().when("hasOfficialNote", {
      is: (hasOfficialNote: boolean) => hasOfficialNote === true,
      then: createAdditionalStudiedSubjectsValidationSchema(),
    }),
    additionalInfo: yup.string().nullable().max(2000, i18n.t("validation.charCount.invalid.2000")),
    prevCertNumber: yup
      .string()
      .nullable()
      .test("required", i18n.t("validation.field.required"), function (_value) {
        const hasOfficialNote = this?.options?.context?.hasOfficialNote;
        const hasCertificate = this?.options?.context?.hasCertificate;
        if (hasOfficialNote && !hasCertificate) {
          return !isEmpty(_value);
        }
        return true;
      }),
  });

  return schema;
};

const createAdditionalStudiedSubjectsValidationSchema = () => {
  return yup.object({
    additionalStudiedSubjectsNote: yup.string().nullable().max(2000, i18n.t("validation.charCount.invalid.2000")),
    additionalStudiedSubjects: yup.array().of(
      yup.object().shape({
        translatedSubjectName: yup.string().nullable().required().max(100, i18n.t("validation.charCount.invalid.100")),
        subjectName: yup.string().nullable().max(100, i18n.t("validation.charCount.invalid.100")),
        classYear: yup.string().nullable().max(50, i18n.t("validation.charCount.invalid.50")),
        diplomaGrade: yup.string().nullable().required().max(20, i18n.t("validation.charCount.invalid.20")),
      }),
    ),
  });
};
